import { render, staticRenderFns } from "./Mfa.vue?vue&type=template&id=0e32f070&scoped=true"
import script from "./Mfa.ts?vue&type=script&lang=ts&external"
export * from "./Mfa.ts?vue&type=script&lang=ts&external"
import style0 from "./Mfa.vue?vue&type=style&index=0&id=0e32f070&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e32f070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e32f070')) {
      api.createRecord('0e32f070', component.options)
    } else {
      api.reload('0e32f070', component.options)
    }
    module.hot.accept("./Mfa.vue?vue&type=template&id=0e32f070&scoped=true", function () {
      api.rerender('0e32f070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/pages/Mfa/Mfa.vue"
export default component.exports